var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "52.431825 164.931746041638 243.75 52.49999874000001",
    zoomAndPan: "magnify",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxHeight: 500
    },
    width: 243.75,
    height: 52.49999874000001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "3a09c9813e"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 58.246094 170.332031 L 99.523438 170.332031 L 99.523438 211.609375 L 58.246094 211.609375 Z M 58.246094 170.332031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f9463ffd8d"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 78.886719 170.332031 C 67.488281 170.332031 58.246094 179.570312 58.246094 190.96875 C 58.246094 202.367188 67.488281 211.609375 78.886719 211.609375 C 90.285156 211.609375 99.523438 202.367188 99.523438 190.96875 C 99.523438 179.570312 90.285156 170.332031 78.886719 170.332031 Z M 78.886719 170.332031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "875096e75c"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 79 177.488281 L 90.085938 177.488281 L 90.085938 208 L 79 208 Z M 79 177.488281"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4779c1196f"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 67.585938 197 L 79 197 L 79 208 L 67.585938 208 Z M 67.585938 197"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a09c9813e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f9463ffd8d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fillOpacity: 1,
    d: "M 58.246094 170.332031 L 99.523438 170.332031 L 99.523438 211.609375 L 58.246094 211.609375 Z M 58.246094 170.332031",
    fill: "#b626f1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#2e2e2e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.374597, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 19.890625 -3.671875 C 18.859375 -2.410156 17.601562 -1.4375 16.125 -0.75 C 14.65625 -0.0625 13.070312 0.28125 11.375 0.28125 C 9.25 0.28125 7.289062 -0.3125 5.5 -1.5 C 3.71875 -2.664062 2.289062 -4.296875 1.21875 -6.390625 L 4.75 -8.1875 C 5.4375 -6.738281 6.375 -5.625 7.5625 -4.84375 C 8.726562 -4.03125 10 -3.625 11.375 -3.625 C 12.914062 -3.625 14.296875 -4.046875 15.515625 -4.890625 C 16.703125 -5.703125 17.644531 -6.941406 18.34375 -8.609375 C 19.03125 -10.234375 19.375 -12.207031 19.375 -14.53125 L 19.375 -30.609375 L 23.265625 -30.609375 L 23.265625 -14.53125 C 23.265625 -12.300781 22.984375 -10.265625 22.421875 -8.421875 C 21.828125 -6.566406 20.984375 -4.984375 19.890625 -3.671875 Z M 19.890625 -3.671875"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#2e2e2e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.317952, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.265625 -5.921875 L 9.265625 -5.921875 L 6.53125 0 L 2.203125 0 L 16.546875 -30.9375 L 30.140625 0 L 25.859375 0 Z M 21.578125 -9.828125 L 16.40625 -21.4375 L 11.046875 -9.828125 Z M 21.578125 -9.828125"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#2e2e2e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.527041, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.265625 -5.921875 L 9.265625 -5.921875 L 6.53125 0 L 2.203125 0 L 16.546875 -30.9375 L 30.140625 0 L 25.859375 0 Z M 21.578125 -9.828125 L 16.40625 -21.4375 L 11.046875 -9.828125 Z M 21.578125 -9.828125"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#2e2e2e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.736131, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8 0 L 4.046875 0 L 4.046875 -31.078125 L 23.9375 -9.59375 L 23.9375 -30.609375 L 27.828125 -30.609375 L 27.828125 0.75 L 8 -20.828125 Z M 8 0"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#2e2e2e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.475063, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 31.078125 -7.515625 C 29.671875 -5.109375 27.789062 -3.210938 25.4375 -1.828125 C 23.050781 -0.421875 20.460938 0.28125 17.671875 0.28125 C 14.859375 0.28125 12.273438 -0.421875 9.921875 -1.828125 C 7.535156 -3.210938 5.65625 -5.109375 4.28125 -7.515625 C 2.894531 -9.898438 2.203125 -12.503906 2.203125 -15.328125 C 2.203125 -18.117188 2.894531 -20.71875 4.28125 -23.125 C 5.6875 -25.507812 7.582031 -27.410156 9.96875 -28.828125 C 12.320312 -30.203125 14.890625 -30.890625 17.671875 -30.890625 C 20.429688 -30.890625 23.019531 -30.203125 25.4375 -28.828125 C 27.820312 -27.410156 29.703125 -25.507812 31.078125 -23.125 C 32.453125 -20.71875 33.140625 -18.117188 33.140625 -15.328125 C 33.140625 -12.535156 32.453125 -9.929688 31.078125 -7.515625 Z M 27.6875 -21.15625 C 26.65625 -22.945312 25.242188 -24.375 23.453125 -25.4375 C 21.671875 -26.46875 19.742188 -26.984375 17.671875 -26.984375 C 15.578125 -26.984375 13.648438 -26.46875 11.890625 -25.4375 C 10.109375 -24.375 8.695312 -22.945312 7.65625 -21.15625 C 6.625 -19.375 6.109375 -17.429688 6.109375 -15.328125 C 6.109375 -13.191406 6.625 -11.234375 7.65625 -9.453125 C 8.695312 -7.660156 10.109375 -6.25 11.890625 -5.21875 C 13.679688 -4.15625 15.609375 -3.625 17.671875 -3.625 C 19.804688 -3.625 21.753906 -4.15625 23.515625 -5.21875 C 25.296875 -6.25 26.703125 -7.660156 27.734375 -9.453125 C 28.742188 -11.234375 29.25 -13.191406 29.25 -15.328125 C 29.25 -17.429688 28.726562 -19.375 27.6875 -21.15625 Z M 27.6875 -21.15625"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#2e2e2e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.740171, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.125 0 C 4.59375 0 4.140625 -0.203125 3.765625 -0.609375 C 3.390625 -0.984375 3.203125 -1.4375 3.203125 -1.96875 C 3.203125 -2.507812 3.40625 -2.96875 3.8125 -3.34375 C 4.1875 -3.71875 4.625 -3.90625 5.125 -3.90625 C 5.65625 -3.90625 6.125 -3.71875 6.53125 -3.34375 C 6.90625 -2.9375 7.09375 -2.476562 7.09375 -1.96875 C 7.09375 -1.4375 6.90625 -0.984375 6.53125 -0.609375 C 6.125 -0.203125 5.65625 0 5.125 0 Z M 5.125 0"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#b626f1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.948807, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.265625 -5.921875 L 9.265625 -5.921875 L 6.53125 0 L 2.203125 0 L 16.546875 -30.9375 L 30.140625 0 L 25.859375 0 Z M 21.578125 -9.828125 L 16.40625 -21.4375 L 11.046875 -9.828125 Z M 21.578125 -9.828125"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fill: "#b626f1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.157896, 206.249986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.5625 -30.609375 L 8.515625 -30.609375 L 8.515625 0 L 4.5625 0 Z M 4.5625 -30.609375"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#875096e75c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fillOpacity: 1,
    d: "M 79.507812 207.984375 L 79.507812 177.496094 L 90.175781 177.496094 L 90.175781 197.316406 C 90.175781 203.207031 85.402344 207.984375 79.507812 207.984375 Z M 79.507812 207.984375",
    fill: "#ffffff"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4779c1196f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fillOpacity: 1,
    d: "M 78.253906 207.984375 C 72.363281 207.984375 67.585938 203.207031 67.585938 197.316406 L 78.253906 197.316406 Z M 78.253906 207.984375",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoj);
export default __webpack_public_path__ + "static/media/logoj.3ab16f0d5a9333fd5cb8e15a2b456f64.svg";
export { ForwardRef as ReactComponent };